import styled from '@emotion/styled'
import type { Brand } from '@/api/brands/type'
import { Avatar, Button, Flex, Text } from '@collable/ui'

interface ManageVideoDetailSearchItemProps {
  brand: Brand
}

const ManageVideoDetailSearchItem = ({ brand }: ManageVideoDetailSearchItemProps) => {
  return (
    <Container justifyContent="space-between" alignItems="center">
      <Flex gap={10} alignItems="center">
        <Avatar size="m" type="sponsor" src={brand.logoUrl} />
        <Text size="body2" fontWeight="medium">
          {brand.brandName}
        </Text>
      </Flex>
      <Button size="medium" kind="solid" color="neutral">
        {brand.brandId ? '선택' : '신규 생성'}
      </Button>
    </Container>
  )
}

export default ManageVideoDetailSearchItem

const Container = styled(Flex)`
  padding: 16px 20px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.fill.fillNeutral};
`
